import { types } from 'mobx-state-tree';


const PAYMENT_FREQUENCIES = {
    WEEKLY: 'weekly',
    ACCELERATED_WEEKLY: 'accelerated-weekly',

    BI_WEEKLY: 'biweekly',
    ACCELERATED_BI_WEEKLY: 'accelerated-biweekly',

    MONTHLY: 'monthly',
    SEMI_MONTHLY: 'semimonthly',

    QUARTERLY: 'quarterly',

    ANNUALLY: 'annually',
};

const PaymentFrequencyEnum = types.enumeration('PaymentFrequency', Object.values(PAYMENT_FREQUENCIES));

export {
    PaymentFrequencyEnum,
};
export default PAYMENT_FREQUENCIES;
